import { Grid } from "antd";
import { withConditionalComponent } from "src/HOC/WithMobileComponent";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import DiscountDetailsSkeletonWeb from "./layouts/DiscountDetailsSkeleton.web";
import DiscountDetailsSkeletonMob from "./layouts/DiscountDetailsSkeleton.mob";

const DiscountDetailsSkeletonComponent = withConditionalComponent(DiscountDetailsSkeletonWeb, DiscountDetailsSkeletonMob);

export default function DiscountDetailsSkeleton() {
  const isLargeScreen = !!Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];

  return <DiscountDetailsSkeletonComponent trigger={isLargeScreen} />;
}
